<template>
  <el-table
    class="assets-table common-el-table-styles"
    ref="table"
    :data="data"
    style="width: 100%"
    border
    stripe
    @sort-change="$emit('sort-change', $event)"
    @row-click="onTableRowClick"
    @select="onSelectChange"
  >
    <el-table-column type="selection" :selectable="rowSelectable" align="left" title="123"> </el-table-column>
    <el-table-column
      v-for="(col, id) in tableCols"
      :key="id"
      :fixed="col.fixed"
      :prop="col.key"
      :label="col.title"
      :show-overflow-tooltip="col.overflow"
      :min-width="col.width"
      :align="col.align"
      :sortable="col.sortable"
      :sort-orders="['descending', 'ascending', null]"
    >
      <template v-slot:default="{ row }">
        <span v-if="col.format">{{ col.format(row) }}</span>
        <template v-else>
          <!-- 素材名称显示浮窗 -->
          <template v-if="col.key === 'imageName'">
            <em v-if="row.ruleId" class="el-icon-warning" style="color: red">素材管控：{{ row.ruleId }}&ensp;</em>

            <el-popover :open-delay="200" trigger="hover" placement="right">
              <video style="min-width: 150px; max-height: 160px" :src="row.addr" controls="controls" />
              <span slot="reference">{{ row[col.key] }}</span>
            </el-popover>
          </template>
          <!-- 其他 -->
          <span v-else>{{ row[col.key] }}</span>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { tableCols } from './consts.js'
export default {
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array
    },
    max: {
      type: Number
    }
  },
  computed: {
    tableCols() {
      return tableCols
    },
    selectedIds() {
      return this.value.map((row) => row.id)
    }
  },
  watch: {
    data() {
      this.initCheckStates()
    },
    selectedIds() {
      this.initCheckStates()
    }
  },
  methods: {
    /**
     * @description: 根据value勾选table
     * @return {*}
     */
    initCheckStates() {
      this.$nextTick(() => {
        this.data.forEach((row) => {
          this.$refs.table.toggleRowSelection(row, this.selectedIds.includes(row.id))
        })
      })
    },
    onSelectChange(selection, row) {
      this.onTableRowClick(row)
    },

    /**
     * @description: 是否被素材管控规则命中
     * @param {*} row
     * @return {*}
     */
    rowSelectable(row) {
      return !row.ruleId
    },

    /**
     * @description: 单行点击切换选中状态
     * @return {*}
     */
    onTableRowClick(row) {
      // 是否被素材管控规则命中
      if (row.ruleId) return

      const rowCheck = !this.selectedIds.includes(row.id)
      let newValue = this.value

      if (this.selectedIds.includes(row.id)) {
        newValue = newValue.filter((r) => r.id !== row.id)
      } else {
        if (this.max > 0 && this.max <= this.value.length) return
        newValue = [...newValue, row.items]
      }

      this.$emit('input', newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.assets-table {
  /* 隐藏表头的全选 */
  ::v-deep thead {
    .el-table-column--selection {
      .el-checkbox {
        visibility: hidden;
      }
    }
  }
}
</style>
